export default __webpack_public_path__ + "images/TD.27b6cba.png";